import { makeRequest } from "../utils/apiUtils";

export const GET_SHORT_LINK = "shortLink/GET_SHORT_LINK";
export const GET_SHORT_LINK_SUCCESS = "shortLink/GET_SHORT_LINK_SUCCESS";
export const GET_SHORT_LINK_FAIL = "shortLink/GET_SHORT_LINK_FAIL";

export const GET_SHORT_LINKS = "shortLink/GET_SHORT_LINKS";
export const GET_SHORT_LINKS_SUCCESS = "shortLink/GET_SHORT_LINKS_SUCCESS";
export const GET_SHORT_LINKS_FAIL = "shortLink/GET_SHORT_LINKS_FAIL";

export function getShortLink(url, id) {
  return makeRequest('/saduka/shortLink', {
    types: [GET_SHORT_LINK, GET_SHORT_LINK_SUCCESS, GET_SHORT_LINK_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({urls: url})
    },
    id,
    url
  })
}

export function getShortLinks(urls) {
  return makeRequest('/saduka/shortLink', {
    types: [GET_SHORT_LINKS, GET_SHORT_LINKS_SUCCESS, GET_SHORT_LINKS_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({urls})
    },
    urls
  })
}
